import { compose } from 'redux';
import { withScriptjs, withGoogleMap } from 'react-google-maps';
import { HotelCardMap } from './HotelCardMap';

const Enhanced = compose(withScriptjs, withGoogleMap)(HotelCardMap);

export { Enhanced as HotelCardMap };
